export default __webpack_public_path__ + "static/media/worry-sketch1.fa417d5c.png";